"use strict";

module.exports = function(orig) {
	return orig.toLowerCase().replace(/[^a-z0-9]/, "-");
};



// WEBPACK FOOTER //
// ./client/js/libs/handlebars/slugify.js